<ng-container *ngFor="let plan of displayPlans; index as i">
  <div
    [ngClass]="plan.isValid ? 'plan-info__plan-list--valid-plan' : 'plan-info__plan-list--invalid-plan'"
    class="p-manage-booking__item p-sub-column-layout01__title"
  >
    <div class="p-manage-booking__item-head p-manage-booking__item-head--has-btn">
      <!-- [タイトル(プラン名)] -->
      <div class="p-manage-booking__item-title">
        <div class="p-manage-booking__item-title">
          <div class="p-heading-area01">
            <h2 class="p-heading-area01__title c-heading-2">{{ plan.planName }}</h2>
          </div>
        </div>
      </div>
      <!-- [//タイトル(プラン名)] -->

      <div class="c-form-element-checkbox">
        <div class="c-form-element-checkbox__wrap">
          <!-- [プラン操作メニューボタン] -->
          <button id="plan-list-plan-infomarion-menu-button" class="c-accordion-btn01 plan-info__menu-button">
            <span class="c-accordion-btn01__text" (click)="clickMenu(select[i].index)">
              <img src="assets/images/icon_menu_20.svg" width="24" height="24" alt="{{ 'alt.editPlan' | staticMsg }}" />
            </span>
          </button>
          <!-- [//プラン操作メニューボタン] -->

          <!-- [プラン選択チェックボックス] -->
          <input
            [id]="select[i].name"
            class="c-form-element-checkbox__input"
            type="checkbox"
            [name]="select[i].name"
            aria-invalid="false"
            [checked]="select[i].checked"
            (change)="selectPlan($event)"
            [disabled]="checkDisabled"
          />
          <label class="c-form-element-checkbox__label" [for]="select[i].name">
            <span class="c-form-element-checkbox__check"></span>
            <span class="u-visually-hidden" [innerHTML]="'reader.selectPlan' | staticMsg"></span>
          </label>
          <!-- [プラン選択チェックボックス] -->
        </div>
      </div>
    </div>

    <div [ngClass]="plan.isValid ? '' : 'plan-info__estimate-datetime--invalid-plan'">
      <!-- [プラン作成日/プラン有効期限] -->
      <div class="c-def-list02__item-body p-payment-method-finance__item-block p-add-other-reserve__head">
        <div class=".p-add-other-reserve__row">
          <span [innerHTML]="'label.createdOn' | staticMsg : { '0': plan.createOn }" class="plan-info__separate"></span>
          <span [innerHTML]="'label.saveUntil' | staticMsg : { '0': plan.saveUntil }"></span>
        </div>
      </div>
      <!-- [//プラン作成日/プラン有効期限] -->

      <ng-container *ngIf="plan.finishGetCart; else noFinishgetBound">
        <!-- [識別子] -->
        <div class="p-add-other-reserve__head">
          <!-- [無効識別子] -->
          <span *ngIf="plan.cartList.isChangedPlan" class="p-flight-detail01__detail-tag">
            <span class="c-tag c-tag--type05">
              <strong [innerHTML]="'label.planInformationChanged' | staticMsg"></strong>
            </span>
          </span>
          <!-- [プラン情報変更識別子] -->
          <span *ngIf="!plan.isValid" class="p-flight-detail01__detail-tag">
            <span class="c-tag c-tag--type05">
              <strong [innerHTML]="'label.flightInvalid2' | staticMsg"></strong>
            </span>
          </span>
          <!-- [マージ識別子] -->
          <span *ngIf="plan.isMerged" class="p-flight-detail01__detail-tag">
            <span class="c-tag c-tag--type06">
              <strong [innerHTML]="'label.marged' | staticMsg"></strong>
            </span>
          </span>
          <!-- [遅延識別子] -->
          <span *ngIf="plan.cartList.isDelayed" class="p-flight-detail01__detail-tag">
            <span class="c-tag c-tag--type01">
              <strong [innerHTML]="'label.delayed' | staticMsg"></strong>
            </span>
          </span>
          <!-- [早発識別子] -->
          <span *ngIf="plan.cartList.isEarlyFlight" class="p-flight-detail01__detail-tag">
            <span class="c-tag c-tag--type01">
              <strong [innerHTML]="'label.earlyDeparture' | staticMsg"></strong>
            </span>
          </span>
        </div>
        <!-- [//識別子] -->

        <div class="c-def-list02">
          <!-- [バウンド情報] -->
          <ng-container *ngIf="isSP; else notSP">
            <asw-plan-list-bound-info-sp [boundList]="plan.cartList.boundList" [isValid]="plan.isValid">
            </asw-plan-list-bound-info-sp>
          </ng-container>
          <ng-template #notSP>
            <asw-plan-list-bound-info [boundList]="plan.cartList.boundList" [isValid]="plan.isValid">
            </asw-plan-list-bound-info>
          </ng-template>
          <!-- [//バウンド情報] -->

          <div class="p-manage-booking p-manage-booking__item-head--has-btn">
            <div class="p-select-flight-panel01__grade-cur">
              <!-- [支払総額] -->
              <div class="p-select-flight-panel01__grade-cur-class">
                <div
                  [ngClass]="
                    plan.isValid ? 'c-plan-table01__col-item--blue' : 'plan-info__estimate-datetime--invalid-plan'
                  "
                >
                  <div>
                    <span class="c-amount c-amount--price">
                      <span class="c-heading-2">
                        <ng-container *ngIf="plan.isValid; else invalidPrice">
                          <!-- 有効プランの場合 -->
                          <ng-container *ngIf="plan.cartList.curTotalPrice; else noCurPrice">
                            <!-- 最新カート情報がある場合 -->
                            <div
                              [ngClass]="plan.cartList.diffTotalPrice ? 'diff' : ''"
                              [innerHTML]="
                                plan.cartList.curTotalPrice | amountFormat : 'default' : plan.cartList.curCurrencyCode
                              "
                            ></div>
                            <span
                              *ngIf="plan.cartList.diffTotalPrice"
                              class="u-visually-hidden"
                              [innerHTML]="'label.changedItem' | staticMsg"
                            ></span>
                          </ng-container>
                          <ng-template #noCurPrice>
                            <!-- 最新カート情報がない場合 -->
                            <del>
                              <div
                                [innerHTML]="
                                  plan.cartList.preTotalPrice ?? 0
                                    | amountFormat : 'default' : plan.cartList.preCurrencyCode
                                "
                              ></div>
                            </del>
                          </ng-template>
                        </ng-container>
                        <ng-template #invalidPrice>
                          <!-- 無効プランの場合 -->
                          <div
                            [ngClass]="plan.cartList.diffTotalPrice ? 'diff' : ''"
                            [innerHTML]="
                              plan.cartList.preTotalPrice ?? 0
                                | amountFormat : 'default' : plan.cartList.preCurrencyCode
                            "
                          ></div>
                          <span
                            *ngIf="plan.cartList.diffTotalPrice"
                            class="u-visually-hidden"
                            [innerHTML]="'label.changedItem' | staticMsg"
                          ></span>
                        </ng-template>
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              <!-- [//支払総額] -->

              <!-- [搭乗者人数] -->
              <asw-plan-list-passenger-info
                class="p-select-flight-panel01__grade-cur-status"
                [isValid]="plan.isValid"
                [curPassenger]="plan.cartList.curPassenger"
                [prePassenger]="plan.cartList.prePassenger"
              >
              </asw-plan-list-passenger-info>
              <!-- [//搭乗者人数] -->
            </div>

            <!-- [詳細ボタン] -->
            <div
              id="plan-list-plan-information-detail-button-1"
              class="c-btn-primary c-btn-primary--s plan-info__detail-button-margin"
            >
              <button
                id="plan-list-plan-information-detail-button-2"
                class="c-btn-primary__text plan-info__detail-button-text"
                [innerHTML]="'label.details3' | staticMsg"
                aswThrottleClick
                (throttleClick$)="clickDetail(select[i].index)"
              ></button>
              <span
                class="u-visually-hidden"
                [innerHTML]="'reader.details' | staticMsg : { '0': plan.planName }"
              ></span>
            </div>
            <!-- [//詳細ボタン] -->
          </div>
        </div>
      </ng-container>

      <ng-template #noFinishgetBound>
        <asw-plan-list-load-bound></asw-plan-list-load-bound>
      </ng-template>
    </div>
  </div>
</ng-container>
